import {inject, Injectable} from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    private localStorageService = inject(LocalStorageService);

    get firstName(): string {
        return this.localStorageService.retrieve('fn') || '';
    }

    set firstName(name: string) {
        this.localStorageService.store('fn', name);
    }

    get lastName(): string {
        return this.localStorageService.retrieve('ln') || '';
    }

    set lastName(lastName: string) {
        this.localStorageService.store('ln', lastName);
    }

    get email(): string {
        return this.localStorageService.retrieve('em') || '';
    }

    set email(email: string) {
        this.localStorageService.store('em', email);
    }

    get lang(): string {
        return this.localStorageService.retrieve('lg') || '';
    }

    set lang(lang: string) {
        this.localStorageService.store('lg', lang);
    }

    get token(): string {
        return this.localStorageService.retrieve('tk') || '';
    }

    set token(token: string) {
        this.localStorageService.store('tk', token);
    }

    get refreshToken(): string {
        return this.localStorageService.retrieve('rtk') || '';
    }

    set refreshToken(refreshToken: string) {
        this.localStorageService.store('rtk', refreshToken);
    }

    get profile(): string {
        return this.localStorageService.retrieve('pf') || '';
    }

    set profile(profile: string) {
        this.localStorageService.store('pf', profile);
    }

    get rememberEmail(): string {
        return this.localStorageService.retrieve('rme') || '';
    }

    set rememberEmail(rememberEmail: string) {
        this.localStorageService.store('rme', rememberEmail);
    }

    isLogged(): boolean {
        return !!this.token;
    }

    reset(): void {
        const rememberEmail = this.rememberEmail;
        this.localStorageService.clear();
        this.rememberEmail = rememberEmail;
    }
}
